// extracted by mini-css-extract-plugin
module.exports = {"heroClassName":"Testimonials_heroClassName__UzsyB","contentClassName":"Testimonials_contentClassName__RIuCu","overlayShadow":"Testimonials_overlayShadow__Makjq"};